export default "/signup/_next/static/chunks/fonts/inter-v3-latin-600-818d792206881ec4beadc3eb32e2ba75.woff";